// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"efced1ad","239":"376689cf","371":"d245b1bc","667":"00135996"}[chunkId] + ".chunk.js";
};